import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import css from './CredentialRow.scss';
import Checkbox from "./Checkbox";

const CredentialRow = (props) => {

    return (
        <Table.Row className={css['credential-row']} data-testid={`credentialRow${props.name.replace(/\s+/g, '')}`}>
            <Table.Cell className={css['credential-info']}>
                {props.name}

            </Table.Cell>
            <Table.Cell>
                <div className={css['checkbox-container']}>
                    <Checkbox onChange={props.onChange} name={props.name} value={props.value} checked={props.checked} id={props.id}/>
                </div>
                </Table.Cell>
        </Table.Row>
    );
};

CredentialRow.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    id: PropTypes.number
};

export default CredentialRow;
